import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import Image from '@base/Image';
import { DownloadIcon } from './Curriculum';
import useCertificationCourseData from './useCertificationCourseData';
import { ENROLLMENT_END_TYPES } from './constants';

const Wrapper = styled.div`
  display: grid;
  margin: auto;
  padding: ${Spacings.SPACING_5B};
  gap: ${Spacings.SPACING_6B};
  width: 336px;
  position: sticky;
  background: var(--color-i-white);
  border: ${Spacings.SPACING_1} solid var(--color-i-gray-14);
  border-radius: ${Spacings.SPACING_2B};
  top: 160px;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
const InfoContainer = styled.div`
  border-bottom: ${Spacings.SPACING_1} solid var(--color-i-gray-14);
  padding-bottom: ${Spacings.SPACING_6B};
  display: grid;
  gap: ${Spacings.SPACING_4B};
`;

const ButtonWrapper = styled.div`
  width: 296px;
  display: grid;
  gap: ${Spacings.SPACING_2B};
`;

const Title = styled(Typography)``;
const SubTitle = styled(Typography)``;

const IconTextWrapper = styled.div`
  margin-top: ${({ $marginTop }) => $marginTop};
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
`;

const Text = styled(Typography)``;

const ImageWrapper = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;

const IconText = ({ text, icon, marginTop }) => {
  return (
    <IconTextWrapper $marginTop={marginTop}>
      <ImageWrapper>
        <Image src={icon} layout="fill" alt="icon" />
      </ImageWrapper>
      <Text variant="p2">{text}</Text>
    </IconTextWrapper>
  );
};

const StyledButton = styled(Button)`
  width: 296px;
  padding: 12px 45px;
  height: 48px;
  font-weight: 600;
  font-size: 16px;
`;

const EnrolledInfoWrapper = styled.div`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_0B};
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  gap: 6px;
  border-radius: ${Spacings.SPACING_1B};
  background: ${({ $background }) => {
    return $background || 'white';
  }};
  width: ${({ $width }) => {
    return $width || '100%';
  }};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const EnrolledIconWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
`;

const EnrolledText = styled(Typography)`
  color: ${({ $color }) => {
    return $color || 'black';
  }};
`;

export const EnrolledInfo = ({ goalUID, width }) => {
  const { overAll = {} } = useCertificationCourseData(goalUID);
  const { enrollmentEndDetails } = overAll;
  if (!enrollmentEndDetails) return null;
  const info = ENROLLMENT_END_TYPES[enrollmentEndDetails?.type];
  return (
    <EnrolledInfoWrapper $background={info.background} $width={width}>
      {info.icon && (
        <EnrolledIconWrapper>
          <Image src={info.icon} layout="fill" alt="enrolled" />
        </EnrolledIconWrapper>
      )}
      <EnrolledText variant="h6" $color={info.color}>
        {enrollmentEndDetails?.label}
      </EnrolledText>
    </EnrolledInfoWrapper>
  );
};

const StickyInfoCard = ({
  goalUID,
  handleIInterestedCTA,
  handleDownloadBrochureCTA
}) => {
  const { overAll = {} } = useCertificationCourseData(goalUID);
  return (
    <Wrapper>
      <InfoContainer>
        <Title variant="h3">{overAll.getExpertCallTitle}</Title>
        <SubTitle variant="h5">{overAll.getExpertCallSubjectDetails}</SubTitle>
        <IconText
          text={overAll?.startInMessage}
          icon="certificationCourses/calendar-outline.svg"
          marginTop="0px"
        />
        <IconText
          text={overAll?.programmeDuration}
          icon="certificationCourses/clock-watch.svg"
          marginTop="-4px"
        />
      </InfoContainer>
      <ButtonWrapper>
        <StyledButton
          onClick={handleIInterestedCTA}
          size="large"
          variant="primary"
          label="I’m interested"
        />
        <StyledButton
          onClick={handleDownloadBrochureCTA}
          size="large"
          variant="secondary"
          label="Download brochure"
          startIcon={<DownloadIcon />}
        />
        <EnrolledInfo goalUID={goalUID} />
      </ButtonWrapper>
    </Wrapper>
  );
};

export default StickyInfoCard;
